import PropTypes from 'prop-types';
import React from 'react';
import { FontIcon } from 'react-toolbox';
import Card from 'components/Card';
import PhaseEventList from './phaseEventList';
import PhaseType from 'types/phase';
import S from './phaseHistoryCard.scss';
import contentAreaStyles from 'styles/contentArea';

class PhaseHistoryCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed,
      icon: props.collapsed ? 'down' : 'up',
      clientHeight: 0,
    };
  }

  // On the first render, the component has no reference to the contentWrapper
  // and its height. We need to trigger another render if the component is
  // initially expanded so that it displays properly.
  componentDidMount = () => (this.contentWrapper !== null ?
    this.setState({ clientHeight: this.contentWrapper.clientHeight }) : null);

  handleClick = () => this.setState({
    collapsed: !this.state.collapsed, icon: this.state.collapsed ? 'up' : 'down',
  });

  render = () => {
    const { collapsed, clientHeight } = this.state;
    const { events, name, isSortByDateTime, phase, isPhaseHistoryTab } = this.props;
    const icon = `arrow_drop_${this.state.icon}`;
    const iconStyle = S.phaseHistoryCard__collapseToggle;
    const heightStyle = {};
    if (collapsed) heightStyle.maxHeight = 0;
    else { heightStyle.maxHeight = (clientHeight || 0) + 500; }
    return (<Card className={`${S.phaseHistoryCard__container} ${contentAreaStyles.contentArea}`}>
      <section className={S.phaseHistoryCard}>
        <div className={S.phaseHistoryCard__title}>
          <span>{name}</span>
          <FontIcon value={icon} onClick={this.handleClick} className={iconStyle} />
        </div>
        <div className={S.phaseHistoryCard__content} style={heightStyle}>
          <div ref={(wrapper) => { this.contentWrapper = wrapper; }}>
            <PhaseEventList
              events={events}
              isSortByDateTime={isSortByDateTime}
              phase={phase}
              isPhaseHistoryTab={isPhaseHistoryTab}
            />
          </div>
        </div>
      </section>
    </Card>);
  }
}

PhaseHistoryCard.defaultProps = { isPhaseHistoryTab: false, phase: null };

PhaseHistoryCard.propTypes = {
  name: PropTypes.string,
  collapsed: PropTypes.bool,
  events: PropTypes.arrayOf(PropTypes.object),
  isSortByDateTime: PropTypes.bool,
  phase: PhaseType,
  isPhaseHistoryTab: PropTypes.bool,
};

export default PhaseHistoryCard;



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/index.jsx